<script>
import MetisMenu from 'metismenujs/dist/metismenujs';
// import store from '@/state/store';
// import { firestore } from 'firebase';

import { menuItems } from './menu';

export default {
  data() {
    return {
      menuItems: menuItems,
      mechanicMenuItems: [
        {
          id: 100,
          label: 'menuitems.menu.text',
          isTitle: true,
        },
        {
          id: 200,
          label: 'Maintenance',
          icon: 'bx bx-wrench',
          subItems: [
            {
              id: 201,
              label: 'Units',
              link: '/production/maintenance/units',
            },
            {
              id: 4,
              label: 'Work Orders',
              link: '/production/maintenance/workOrders',
            },
          ],
        },
      ],
      supervisorMenuItems: [
        {
          id: 100,
          label: 'menuitems.menu.text',
          isTitle: true,
        },
        {
          id: 200,
          label: 'Dashboard',
          icon: 'bx-home-circle',
          link: '/',
        },
        {
          id: 300,
          label: 'Jobs',
          icon: 'bx-diamond',
          subItems: [
            {
              id: 301,
              label: 'Create Job',
              link: '/production/jobs/createJob',
            },
            {
              id: 302,
              label: 'Search Jobs',
              link: '/production/jobs/searchJobs',
            },
          ],
        },
        {
          id: 400,
          label: 'Safety Forms',
          icon: 'bx-task',
          subItems: [
            {
              id: 401,
              label: 'Submit Forms',
              link: '/production/safety/submitSafetyForm',
            },
            {
              id: 401,
              label: 'Manage Forms',
              link: '/production/safety/manageSafetyForms',
            },
            {
              id: 402,
              label: 'Reports',
              link: '/production/safety/safetyFormSummaryReport',
            },
          ],
        },
        {
          id: 500,
          label: 'Products',
          icon: 'bx bx-purchase-tag-alt',
          link: '/production/products',
        },
        {
          id: 600,
          label: 'Maintenance',
          icon: 'bx bx-wrench',
          subItems: [
            {
              id: 601,
              label: 'Units',
              link: '/production/maintenance/units',
            },
            {
              id: 602,
              label: 'Work Orders',
              link: '/production/maintenance/workOrders',
            },
          ],
        },
        {
          id: 700,
          label: 'Inventory',
          icon: 'bx-hive',
          link: '/production/inventory/inventoryContainer',
        },
        {
          id: 800,
          label: 'Reports',
          icon: 'bx-bar-chart-alt-2',
          subItems: [
            {
              id: 801,
              label: 'Hours Worked',
              link: '/production/reports/hoursWorked',
            },
            {
              id: 802,
              label: 'Employee Hours',
              link: '/production/reports/employeeHours',
            },
            {
              id: 803,
              label: 'Cost Vs Earnings',
              link: '/production/reports/costEarnings',
            },
            {
              id: 804,
              label: 'Documents',
              link: '/production/reports/documentsReport',
            },
          ],
        },
      ],
    };
  },
  mounted: async function () {
    let userPositions = this.$store.state.auth.userRoles;
    if (userPositions.includes('Admin')) {
      this.menuItems = menuItems;
    } else if (userPositions.includes('Supervisor')) {
      this.menuItems = this.supervisorMenuItems;
    } else if (userPositions.includes('Mechanic')) {
      this.menuItems = this.mechanicMenuItems;
    }

    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu');
    var links = document.getElementsByClassName('side-nav-link-ref');
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active');
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('mm-active');
        const parent2 = parent.parentElement.closest('ul');
        if (parent2 && parent2.id !== 'side-menu') {
          parent2.classList.add('mm-show');

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('mm-active');
            var childAnchor = parent3.querySelector('.has-arrow');
            var childDropdown = parent3.querySelector('.has-dropdown');
            if (childAnchor) childAnchor.classList.add('mm-active');
            if (childDropdown) childDropdown.classList.add('mm-active');

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== 'side-menu') {
              parent4.classList.add('mm-show');
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== 'side-menu') {
                parent5.classList.add('mm-active');
                const childanchor = parent5.querySelector('.is-parent');
                if (childanchor && parent5.id !== 'side-menu') {
                  childanchor.classList.add('mm-active');
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ $t(item.label) }}
        </li>
        <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
          <a
            v-if="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
            <span
              :class="`badge badge-pill badge-${item.badge.variant} float-right`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>

          <router-link
            :to="item.link"
            v-if="!hasItems(item)"
            class="side-nav-link-ref"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
            <span
              :class="`badge badge-pill badge-${item.badge.variant} float-right`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </router-link>

          <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li v-for="(subitem, index) of item.subItems" :key="index">
              <router-link
                :to="subitem.link"
                v-if="!hasItems(subitem)"
                class="side-nav-link-ref"
                >{{ $t(subitem.label) }}</router-link
              >
              <a
                v-if="hasItems(subitem)"
                class="side-nav-link-a-ref has-arrow"
                href="javascript:void(0);"
                >{{ $t(subitem.label) }}</a
              >
              <ul
                v-if="hasItems(subitem)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
              >
                <li
                  v-for="(subSubitem, index) of subitem.subItems"
                  :key="index"
                >
                  <router-link
                    :to="subSubitem.link"
                    class="side-nav-link-ref"
                    >{{ $t(subSubitem.label) }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
